export default function AppTableBody({ children, className, onClick, ...rest }) {
    return (
        <div className={`tableBody ${className}`} onClick={onClick} {...rest}>
            {children}
        </div>
    );
};
